import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../AuthContext";
import { Award } from "lucide-react";

export default function MyCourses() {
  const { API } = useAuth();
  const [enrollments, setEnrollments] = useState([]);

  useEffect(() => {
    axios.get(`${API}/my/enrollments`, { withCredentials: true }).then((r) => setEnrollments(r.data));
  }, [API]);

  return (
    <div className="space-y-6">
      <div>
        <div className="overline">Progress</div>
        <h1 className="font-heading text-3xl md:text-4xl font-semibold text-[#0A231C]">My Learning</h1>
      </div>

      {enrollments.length === 0 ? (
        <div className="card-surface p-10 text-center text-[#5C5C5C]">No enrollments yet.</div>
      ) : (
        <div className="grid md:grid-cols-3 gap-6" data-testid="my-courses-grid">
          {enrollments.map((e) => e.course && (
            <div key={e.id} className="card-surface course-card">
              <div className="h-40 overflow-hidden rounded-t-[14px]">
                <img src={e.course.cover_image} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="p-5">
                <div className="overline">{e.course.category}</div>
                <div className="font-heading font-semibold mt-1">{e.course.title}</div>
                <div className="mt-3 h-1.5 bg-[#E5E3D8] rounded-full overflow-hidden">
                  <div className="h-full bg-[#0A231C]" style={{ width: `${e.progress}%` }} />
                </div>
                <div className="mt-2 text-xs text-[#5C5C5C]">{e.progress}% complete</div>
                <div className="mt-4 flex gap-2">
                  <a href={`/courses/${e.course.id}`} className="btn-outline text-sm">Continue</a>
                  {e.progress >= 100 && (
                    <a
                      href={`${API}/certificates/${e.course.id}`}
                      className="btn-primary text-sm flex items-center gap-1"
                      data-testid={`cert-${e.course.id}`}
                    >
                      <Award size={14} /> Certificate
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
